import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/gateways/dlocal.png")